<template>
  <div>
    <div>
      <div class="bordered-tabs d-flex justify-content-between">
        <strong class="h5 font-weight-black">
          {{ locale.list }} {{ locale.debtorAssets.tabTitle }}
        </strong>
        <div>
          <naj-button
            :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.debtorAssetsConfirmation}`] && isNotCompleted)"
            color="primary"
            @click="addNewHandler"
          >
            <v-icon
              left
              v-text="`mdi-plus`"
            ></v-icon>
            {{ local.common.add }}
          </naj-button>
          <!-- <naj-button
          color="primary"
          @click="importDataHandler"
        >
          {{ locale.importData }}
        </naj-button> -->
        </div>
      </div>
      <div>
        <p>
          {{ locale.debtorAssets.totalCount }}
          <strong class="totalCount">
            {{ pagination.totalCount ? pagination.totalCount : 0 }}
          </strong>
          {{ locale.debtorAssets.totalSum }}
          <strong class="totalCount">
            {{ totalSum ? totalSum : 0 }}
          </strong>
        </p>
      </div>
      <div>
        <slot />
      </div>
      <div>
        <v-row>
          <v-col>
            <naj-item-table
              :data-items="debtorAssets.list"
              :headers="headers"
              :pagination="pagination"
              :loading="loading"
              :items-per-page="pagination.pageSize"
              :server-items-length="pagination.totalCount"
              :enable-expand="false"
              @update:page="onPageChange"
            >
              <template
                slot="view"
                slot-scope="{item}"
              >
                <naj-button
                  outlined
                  @click="viewData(item)"
                >
                  {{ local.common.show }}
                </naj-button>
              </template>
              <template
                slot="actionEdit"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.debtorAssetsConfirmation}`] && isNotCompleted)"
                  outlined
                  @click="showUpdateModal(item)"
                >
                  {{ local.common.update }}
                </naj-button>
              </template>
              <template
                slot="actionDelete"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.partnersConfirmation}`] && isNotCompleted)"
                  type="button"
                  color="error"
                  outlined
                  @click="showPopupRemove(item)"
                >
                  {{
                    local.common.remove
                  }}
                </naj-button>
              </template>
            </naj-item-table>
          </v-col>
        </v-row>
      </div>
    </div>
    <naj-modal
      ref="debtorAssetModal"
      :title="isEditMode? `${local.common.update} ${locale.debtorAssets.debtorAsset}` : viewMode ? `${local.common.show} ${locale.debtorAssets.debtorAsset}` : `${local.common.add} ${locale.debtorAssets.debtorAsset}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <v-form ref="debtorAssetForm">
        <debtor-asset-form
          :form-model="formModel"
          :loading="loading"
          :view-mode="viewMode"
        ></debtor-asset-form>
      </v-form>
      <template slot="actions">
        <naj-button
          v-if="!viewMode"
          :loading="loading"
          @click="submit"
        >
          {{ isEditMode? local.common.update :local.common.add }}
        </naj-button>
      </template>
    </naj-modal>
    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeDebtorAsset"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import DebtorAssetForm from './debtor-asset-form.vue';
import { createNamespacedHelpers } from 'vuex';
import { mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { DebtorAssetForm },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      formModel: {},
      loading: false,
      viewMode: false,
      debtorAssets: { list: [] },
      totalSum: 0,
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'assetType',
          text: this.local.bankruptcy.requestDetails.debtorAssets.assetType,
        },
        {
          value: 'assetValue',
          text: this.local.bankruptcy.requestDetails.debtorAssets.assetValue,
        },
        {
          value: 'actionEdit',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
        {
          value: 'actionDelete',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      isEditMode: false,
      mainRequestAuditFlag,
      requestStatusEnum,
      showRemovePopup: false,
      selectedItem: {},
    };
  },
  computed: {
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isNotCompleted',
    ]),
    ...mapState({ auditConfirmations: state => state.auditConfirmations }),
  },
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['submitAddNewDebtorAsset', 'getDebtorAssetsByRequestObjectKey', 'getDebtorAsset', 'updateDebtorAsset', 'deleteDebtorAsset']),
    addNewHandler() {
      this.$refs.debtorAssetModal.show();
    },
    importDataHandler() { },
    loadData() {
      this.loading = true;
      this.totalSum = 0;
      this.getDebtorAssetsByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.debtorAssets = { ...data };
          this.debtorAssets.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });
          if (this.debtorAssets.list.length)
            this.totalSum = this.debtorAssets.list[0].totalSum;

          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    showPopupRemove(item) {
      this.showRemovePopup = true;
      this.selectedItem = item;
    },
    removeDebtorAsset() {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: this.selectedItem.objectKey,
      };
      this.loading = true;
      this.deleteDebtorAsset(params)
        .then(() => {
          this.loadData();
          this.toaster.success(this.local.bankruptcy.common.removeSuccessfully);
        })
        .finally(() => {
          this.loading = false;
          this.showRemovePopup = false;
        });
    },
    submit() {
      if (this.$refs.debtorAssetForm)
        this.$refs.debtorAssetForm.$validator.validateAll().then((valid) => {
          if (valid) {
            this.loading = true;
            this.formModel.requestObjectKey = this.requestObjectKey;
            const method = this.formModel.objectKey ? 'updateDebtorAsset' : 'submitAddNewDebtorAsset';
            this[method]({
              requestObjectKey: this.requestObjectKey,
              ...this.formModel,
            })
              .then(() => {
                const message = this.formModel.objectKey ? 'updateSuccessfully' : 'addedSuccessfully';
                this.$refs.debtorAssetModal.close();
                this.loadData();
                this.toaster.success(this.local.bankruptcy.common[message]);
              })
              .finally(() => { this.loading = false; });
          }
        });
    },
    resetForm() {
      this.$refs.debtorAssetForm.$validator.reset();
    },
    showUpdateModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getDebtorAsset(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.debtorAssetModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
      this.viewMode = false;
      this.isEditMode = false;
      this.resetForm();
    },
    viewData(item) {
      this.viewMode = true;
      this.formModel = Object.assign({}, item);
      this.$refs.debtorAssetModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: var(--app-light-secondary-color) 0% 0% no-repeat padding-box;
}

.totalCount {
  padding: 6px;
  margin-right: 2px;
  margin-left: 13px;
  background-color: black;
  font-size: 13px;
  color: white;
}

div p {
  font-size: 15px;
}
</style>
